/* globals angular */
(function () {
  'use strict';

  angular.module('wsLrs.services').factory('CustomDateFilter', ['Logger', function (Logger) {
    var defaultFilter = {
      dateType: 'trailing',
      trailingAmount: 1,
      trailingType: 'days',
      customDateFrom: null,
      customDateTo: null
    };
    return {
      index: null,
      name: 'New Custom Date Filter',
      dateFilter: Object.assign({}, defaultFilter),
      showCreationView: false,
      savedCopy: null,
      error: '',
      clearError: function clearError() {
        this.error = '';
      },
      reset: function reset() {
        this.index = null;
        this.name = 'New Custom Date Filter';
        this.dateFilter = Object.assign({}, defaultFilter);
        this.showCreationView = false;
        this.error = '';
        this.savedCopy = null;
        return this;
      },
      edit: function edit(customDateFilter, index) {
        var self = this;
        customDateFilter.complexTrailingOption = customDateFilter.dateFilter.trailingAmount === 1 ? "1" : "0";

        // Note we're using a deep-copy trick here
        // so that we are copying by VALUE not REFERENCE
        this.savedCopy = JSON.parse(JSON.stringify({
          name: customDateFilter.name,
          dateFilter: customDateFilter.dateFilter
        }));
        Object.keys(customDateFilter).forEach(function (key) {
          self[key] = customDateFilter[key];
        });
        this.index = index;
      },
      revertCustomDateFilterChanges: function revertCustomDateFilterChanges(customDateFilter) {
        var self = this;
        if (!this.savedCopy) {
          Logger.warn("Tried to revert custom date filter changes, but we had no changes to revert to!");
        }
        Object.keys(self.savedCopy).forEach(function (key) {
          customDateFilter[key] = self.savedCopy[key];
        });
        this.savedCopy = null;
        return customDateFilter;
      }
    };
  }]);
})(this);
